import React, { Component } from "react"

import clsx from 'clsx'

import { connect } from 'react-redux'

import { bindActionCreators } from 'redux'
import * as calledsActions from '../../redux/actions/calleds'
import { AbilityContext } from '../../config/ability-context'

import { FormattedMessage } from 'react-intl'
import { injectIntl } from 'react-intl'

import PropTypes from "prop-types"

import Api from "../../services/api"
import ApiReports from "../../services/apireport";
import ScheduleReportButton from "../../components/report-schedule";

import moment from "moment"

import { withStyles } from "@mui/styles"
import { Styles } from "../../styles/material-styles"
import { Overlay } from "../../styles/global"

import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import Pagination from '@mui/material/Pagination'
import Divider from '@mui/material/Divider'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { CssBaseline, CircularProgress, Container, Button, Grid } from "@mui/material"

import Footer from '../../components/footer'
import CustomizedSnackbars from "../../components/material-snackbars"
import HeaderMenu from "../../components/header-menu"
import SimpleDatePicker from '../../components/date-pickers/inline-no-today'
import SimpleAutoCompleteMultiple from '../../components/auto-complete/autocomplete-multiple'
import CollapsibleMaterialTable from "src/components/table/collapsible-material-table"
import RealSimpleAutoComplete from "../../components/auto-complete/autocomplete-with-onclick";

import { PapiroConsole } from "../../utils/papiroConsole"
import { formatIntervalToReadable } from "src/utils/breakReason"

import LogoMarca from '../../images/new-logo-cmtech.png'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

class BreakWorkReport extends Component {

  constructor(props) {
    super(props)

    this.isClient = true
    this.isAdm = false

    const { userSession } = this.props

    if (userSession == null || userSession.user == null || userSession.user.userrole == null)
      Api.logoff()

    userSession.user.userrole.map((item, key) => {
      if (item.role.roletype != 3)
        this.isClient = false
      if (item.role.roletype == 0 || item.role.roletype == 1)
        this.isAdm = true
    });

    this.state = {
      loading: false,
      openNotification: false,
      notificationVariant: "error",
      notificationMessage: "",

      showGrid: false,

      dateStart: moment().format('YYYY/MM/DD HH:mm:ss'),
      dateEnd: moment().format('YYYY/MM/DD HH:mm:ss'),
      breakReason: null,
      userAgentId: null,

      breakWorkPaginate: [],
      allBreakReasons: [],
      allUsersAgents: [],
      loadingAllUsersAgents: false,

      totalPages: 0,
      page: 1,
      pageStart: 0,
      pageEnd: 0,
      count: 0,

      showHeader: false,

      headColumns: [],
      bodyColumns: [],

      defaultBreakReasonFilter: [
        { id: 7, name: "Login" },
        { id: 5, name: "Logout" },
        { id: 6, name: "Sessão Expirada" },
      ]
    }

    this.getAllUsersAgents = this.getAllUsersAgents.bind(this);
    this.clear = this.clear.bind(this);
  }

  async componentDidMount() {
    this.setState({ loading: true })

    await this.getAllBreakReasons()

    this.setState({ loading: false })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location.state === "reload")
      this.componentDidMount()
  }

  changeValues = async (stateName, value, text = '') => {
    this.setState({ loading: true })

    PapiroConsole.log(value)
    PapiroConsole.log("value")

    if (stateName === "userAgentId" && value) {
      this.setState({ [stateName]: value?.id ?? null });
    } else {
      this.setState({ [stateName]: value });
    }


    this.setState({ loading: false })
  };

  Reload = () => {
    const reload = localStorage.getItem('reload')
    if (reload == "true")
      localStorage.setItem('reload', false)
    return null;
  }

  onChangePaginate = (e, page) => {
    this.setState({ page: page })
    this.getBreakWorksPaginate(page)
  }

  setPagination = (count, page) => {
    let totalPage = Math.ceil(count / 10)
    this.setState({ totalPages: totalPage })
    if (count > 0) {
      if (page == 1) {
        if (count < 10)
          this.setState({ pageStart: 1, pageEnd: count })
        else
          this.setState({ pageStart: 1, pageEnd: 10 })
      } else {
        let pageStart = ((page - 1) * 10) + 1
        if (count >= page * 10)
          this.setState({ pageStart: pageStart, pageEnd: page * 10 })
        else
          this.setState({ pageStart: pageStart, pageEnd: count })
      }
    } else
      this.setState({ totalPages: 0, page: 1, count: 0 })
  }

  getAllBreakReasons = async () => {
    const intl = this.props.intl;

    this.setState({ loading: true });

    try {
      let url = `/break-reason/get-all`;
      const result = await Api.get(url);

      const response = result.data;

      if (response.success) {
        const data = response.data;

        const formattedData = data.map(item => {
          const nameValue = item.name ? item.name : '';
          return {
            ...item,
            name: nameValue,
          }
        });

        this.setState({
          loading: false,
          allBreakReasons: formattedData,
        });
      } else {
        this.setState({
          loading: false,
          openNotification: true,
          notificationVariant: "error",
          notificationMessage:
            response.data && response.data.errors
              ? response.data.errors[0]
              : intl.formatMessage({ id: "process.error" }),
        });
      }
    } catch (err) {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: "error",
        notificationMessage:
          err.response && err.response.data && err.response.data.errors
            ? err.response.data.errors[0]
            : intl.formatMessage({ id: "process.error" }),
      });

    } finally {
      this.setState({ loading: false });
    }
  }

  getAllUsersAgents = async () => {
    if (this.state.loadingAllUsersAgents || this.state.allUsersAgents.length > 0) return;

    const intl = this.props.intl;

    this.setState({ loadingAllUsersAgents: true });

    try {
      let url = `/users/agents`;
      const result = await Api.get(url);
      const response = result.data;

      if (response.success) {
        const data = response.data;

        const formattedData = data.map(item => {
          const nameValue = item.name ? item.name : '';
          return {
            ...item,
            name: nameValue,
          }
        });

        this.setState({
          loadingAllUsersAgents: false,
          allUsersAgents: formattedData,
        });
      } else {
        this.setState({
          loadingAllUsersAgents: false,
          openNotification: true,
          notificationVariant: "error",
          notificationMessage: response.data && response.data.errors
            ? response.data.errors[0]
            : intl.formatMessage({ id: "process.error" }),
        });
      }
    } catch (err) {
      this.setState({
        loadingAllUsersAgents: false,
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: err.response && err.response.data && err.response.data.errors
          ? err.response.data.errors[0]
          : intl.formatMessage({ id: "process.error" }),
      });
    } finally {
      this.setState({ loading: false });
    }
  }

  getFile = async () => {
    this.setState({ loading: true })

    var dateStart = moment(this.state.dateStart).format('YYYY-MM-DD');
    var dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD');
    var breakReasonIds = this.state.breakReason ? this.state.breakReason.map(item => item.id).join(',') : null;
    var userAgentId = this.state.userAgentId;

    if (dateStart > dateEnd) {
      const { intl } = this.props;

      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "report.audit.initial.date.higher.than.end.date" }),
        loading: false
      });

      return;
    }

    const diffMonths = moment(dateEnd).diff(moment(dateStart), 'months', true);
    if (diffMonths > 6) {
      const { intl } = this.props;

      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "report.date.range.exceeds.six.months" }),
        loading: false
      });

      return;
    }

    let data = {
      DateStart: dateStart,
      DateEnd: dateEnd,
      BreakReasonIds: breakReasonIds,
      UserAgentId: userAgentId,
    }

    let url = `/report/breakWork/excel`;

    ApiReports.post(url, data)
      .then((response) => {

        if (response.data.success) {

          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'success',
            notificationMessage: this.props.intl.formatMessage({ id: "report.sent" }) + " (" + this.props.userSession.user.email + ")",
          });
        } else {
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'error',
            notificationMessage: response.data.errors && response.data.errors[0] ? response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
          });
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          openNotification: true,
          notificationVariant: 'error',
          notificationMessage: error.data && error.data.response && error.data.response.data && error.data.response.data.errors && error.data.response.data.errors[0] ? error.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
        });
      });
  }

  getColumns() {
    const intl = this.props.intl;

    var headColumns =
      [
        { title: intl.formatMessage({ id: "tab.called.report.username" }), field: 'username' },
        { title: intl.formatMessage({ id: "break.work.table.userid" }), field: 'userid' },
      ];

    var bodyColumns =
      [
        { title: intl.formatMessage({ id: "break.work.table.reason" }), field: 'breakreasonname' },
        { title: intl.formatMessage({ id: "break.work.table.start" }), field: 'startdate' },
        { title: intl.formatMessage({ id: "break.work.table.end" }), field: 'enddate' },
        { title: intl.formatMessage({ id: "break.work.table.duration" }), field: 'breakduration' },
        { title: intl.formatMessage({ id: "break.work.table.limit" }), field: 'breaklimit' },
        { title: intl.formatMessage({ id: "break.work.table.exceeded" }), field: 'overflowtime' },
      ];

    this.setState({
      headColumns,
      bodyColumns
    })

  }

  getLoginHistoryType(type) {
    switch (type) {
      case 5:
        return "Logout"
      case 6:
        return "Sessão expirada"
      default:
        return "Login"
    }
  }

  clear() {
    document.location.reload();
  }

  groupByUserId(arr) {
    if (!Array.isArray(arr) || arr.length === 0) {
      return [];
    }

    const map = {};

    arr.forEach(item => {
      const key = item.userid !== undefined && item.userid !== null
        ? item.userid
        : 0;

      if (!map[key]) {
        map[key] = [];
      }

      map[key].push(item);
    });

    const result = Object.keys(map)
      .sort((a, b) => {
        if (a === 0) return 1;
        if (b === 0) return -1;
        return b - a;
      })
      .map(key => ({
        userid: key,
        username: map[key][0].username,
        type: "breakWorkPaginate",
        userList: map[key]
      }));

    return result;
  }

  getBreakWorksPaginate = async (page = 1) => {
    this.setState({ loading: true });

    var dateStart = moment(this.state.dateStart).format('YYYY-MM-DD');
    var dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD');
    var breakReasonIds = this.state.breakReason ? this.state.breakReason.map(item => item.id).join(',') : null;
    var userAgentId = this.state.userAgentId;

    if (dateStart > dateEnd) {
      const { intl } = this.props;

      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "report.audit.initial.date.higher.than.end.date" }),
        loading: false
      });

      return;
    }

    const diffMonths = moment(dateEnd).diff(moment(dateStart), 'months', true);
    if (diffMonths > 6) {
      const { intl } = this.props;

      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "report.date.range.exceeds.six.months" }),
        loading: false
      });

      return;
    }

    let url = `/report/breakWork/paginate`

    url += `?page=${page}`
    url += `&dateStart=${dateStart}`
    url += `&dateEnd=${dateEnd}`

    if (breakReasonIds)
      url += `&breakReasonIds=${breakReasonIds}`

    if (userAgentId)
      url += `&userAgentId=${userAgentId}`

    this.setState({ showGrid: true, scheduleRequest: url })

    ApiReports.get(url)
      .then(result => {
        if (result.data.success) {
          let count = result.data.count
          this.setState({ count: count })
          this.setPagination(count, page)

          const data = result.data.data;

          const formattedList = data.map(item => {
            const isBreakWork = item.type === 'break_work';

            const breakreasonname = isBreakWork ? item.breakreasonname : this.getLoginHistoryType(item.idbreakreason);

            return {
              ...item,
              id: isBreakWork ? item.id : item.loginhistoryid,
              breakreasonname,
              startdate: item.startdate ? moment(item.startdate).format('DD/MM/YYYY HH:mm:ss') : '',
              enddate: item.enddate ? moment(item.enddate).format('DD/MM/YYYY HH:mm:ss') : '',
              breaklimit: formatIntervalToReadable(item.breaklimit),
              breakduration: formatIntervalToReadable(item.breakduration),
              overflowtime: isBreakWork
                ? item.overflowtime ? formatIntervalToReadable(item.overflowtime) : 'Não execedeu'
                : null,
            }
          })
          const listGrouped = this.groupByUserId(formattedList);

          this.setState({ breakWorkPaginate: listGrouped, loading: false })

          this.getColumns()

        } else {
          this.setState({
            loading: false, openNotification: true, notificationVariant: 'error',
            notificationMessage: result.data && result.data.errors && result.data.errors[0] ? result.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
          })
          Api.kickoff(result)
        }
      })
      .catch(err => {
        this.setState({
          loading: false, openNotification: true, notificationVariant: 'error',
          notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
        })
        Api.kickoff(err)
      })

  }

  handleSubmit = async e => {
    e.preventDefault();

    this.setState({ loading: true });

    await this.getBreakWorksPaginate(1);
  }

  closeNotification = _ => {
    this.setState({ openNotification: false });
  }

  render() {
    const { classes, headerMenu, actionsHeaderMenu } = this.props
    const intl = this.props.intl

    if (Api == null) {
      var l = this.props.match.params.lang;
      document.location.href = `/${l}/unavailable`
    }

    const tableList = () => {
      if (!this.state.showGrid) return null;

      return (
        <React.Fragment>
          <Grid container xs={12}>
            <CollapsibleMaterialTable
              headColumns={this.state.headColumns}
              bodyColumns={this.state.bodyColumns}
              bodyData={this.state.breakWorkPaginate}
              mainListKey={"userList"}
              allOpened
            />
          </Grid>

          <Grid container style={{ marginBottom: 12, marginTop: 8 }}>
            <Grid item xs={12} md={3}>
              <Pagination count={this.state.totalPages} page={this.state.page} onChange={this.onChangePaginate} />
            </Grid>
            <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
              {this.state.pageStart} {<FormattedMessage id="to" />} {this.state.pageEnd} {<FormattedMessage id="of" />} {this.state.count} {<FormattedMessage id="register" />}
            </Grid>
          </Grid>
        </React.Fragment>
      )
    }

    return (
      <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })} >
          <div className={classes.drawerHeader} />
          <Container component='main' maxWidth='xl' style={{ maxWidth: '100%', paddingLeft: 0, marginLeft: 0 }}>
            <CssBaseline />
            {this.state.showHeader &&
              <Grid container>
                <Grid id="header-pdf" item lg={4} sm={12} xl={this.state.grid} xs={12} style={{ padding: '2px' }}>
                  <Card >
                    <CardContent>
                      <img src={LogoMarca} style={{ width: "70px" }} /> <span style={{ marginLeft: 25, fontSize: 18 }}>

                        <FormattedMessage id="break.reason.records" />
                      </span>
                      <Divider />
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            }

            <Grid container spacing={6}>
              <Grid item xs={12} sm={12}>
                <Card >
                  <CardContent className="background-title-search">
                    <Typography variant="h5">
                      <FormattedMessage id="break.reason.records" />
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            <form name='myForm' className={classes.form} onSubmit={this.handleSubmit} encType='multipart/form-data'>
              <Accordion >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className={classes.heading}>{intl.formatMessage({ id: "filters" })}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container style={{ marginBottom: 20 }} spacing={2}>
                    <Grid item xs={12} sm={6} md={4}  >
                      <SimpleDatePicker label={intl.formatMessage({ id: "start.date" })} name='dateStart' stateName='dateStart' changeDate={this.changeValues} currentDate={this.state.dateStart} fullWidth={true} required />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} >
                      <SimpleDatePicker label={intl.formatMessage({ id: "end.date" })} name='dateEnd' stateName='dateEnd' changeDate={this.changeValues} currentDate={this.state.dateEnd} fullWidth={true} required />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} >
                      <SimpleAutoCompleteMultiple label={intl.formatMessage({ id: "break.reason.form" })} options={[...this.state.defaultBreakReasonFilter, ...this.state.allBreakReasons]} stateName='breakReason' changeSelect={this.changeValues} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} >
                      <RealSimpleAutoComplete
                        style={{
                          background: "white",
                          fullWidth: true,
                        }}
                        label={intl.formatMessage({ id: "menu.users-agents" })}
                        options={this.state.allUsersAgents}
                        stateName="userAgentId"
                        changeSelect={this.changeValues}
                        onFocus={this.getAllUsersAgents}
                        loading={this.state.loadingAllUsersAgents}
                        selected={this.state.allUsersAgents.find(
                          (item) =>
                            item.id === this.state.userAgentId
                        )}
                      />
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Grid container style={{ marginBottom: 10 }}>
                <Grid item xs={12} sm={2} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                  <Button
                    type='submit'
                    fullWidth
                    variant='contained'
                    color='secondary' >
                    {<FormattedMessage id="filter" />}
                  </Button>
                </Grid>

                {this.state.showGrid &&
                  <>
                    <Grid item xs={12} sm={5} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                      <Button
                        fullWidth
                        variant='contained'
                        color='secondary'
                        onClick={this.getFile}
                        disabled={this.state.count === 0}
                      >
                        {<FormattedMessage id="export.plan" />}
                      </Button>
                    </Grid>
{this.state.showGrid && this.state.scheduleRequest && <Grid item xs={12} sm={5} md={2} style={{ marginRight: 10, marginTop: 10 }}>
  <ScheduleReportButton reportKey="break-work" request={this.state.scheduleRequest} color="secondary" />
</Grid>}

                    <Grid item xs={12} sm={2} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                      <Button
                        type='button'
                        fullWidth
                        variant='outlined'
                        color='secondary'
                        onClick={this.clear}
                      >
                        {<FormattedMessage id="clear" />}
                      </Button>
                    </Grid>
                  </>
                }
              </Grid>
            </form>

            {tableList()}


            {this.state.loading && (
              <Overlay>
                <CircularProgress color="secondary" />
              </Overlay>
            )}

            <CustomizedSnackbars
              variant={this.state.notificationVariant}
              message={this.state.notificationMessage}
              isOpen={this.state.openNotification}
              toClose={this.closeNotification} />
          </Container>
        </main>
        <Footer />
      </div>
    )
  }
}

BreakWorkReport.propTypes = {
  classes: PropTypes.object.isRequired
}


const mapStateToProps = state => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(calledsActions, dispatch)

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(BreakWorkReport)))
BreakWorkReport.contextType = AbilityContext